import { Icon } from '@amumin/ui-core';

import { LinkButton } from '../lib/ui.js';
import { appText, context } from '../state/session.js';
import styles from './billing.module.css';

/**
 * 0065: rustige banner als de proefmaand (of het abonnement) voorbij is: alles blijft zichtbaar,
 * wijzigen geeft 402 subscription_expired. Geen alarmkleur, geen schuld; één knop naar betalen.
 * Op de abonnementspagina zelf niet (daar staat het al).
 */
export function BillingBanner({ path }: { path: string }) {
  const ctx = context.value;
  const active = ctx?.households.find((h) => h.id === ctx.active_household_id);
  if (!active?.billing_locked || path.startsWith('/instellingen/abonnement')) return null;
  const b = appText.value.billing.banner;
  const parent = active.role === 'owner' || active.role === 'parent';
  return (
    <div class={styles.banner} role="status" data-name="billing-banner">
      <span class={styles.bannerIcon} aria-hidden="true">
        <Icon id="eye" size={20} />
      </span>
      <div class={styles.bannerText}>
        <strong>{b.expiredTitle}</strong>
        <p>{b.expiredBody}</p>
      </div>
      {parent ? (
        <LinkButton
          href="/instellingen/abonnement"
          variant="primary"
          size="small"
          name="billing-banner-pay"
        >
          {b.pay}
        </LinkButton>
      ) : null}
    </div>
  );
}
